import React from 'react';

export const GiphyCommandIcon: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
    <path
      fill='#000'
      d='M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z'
    ></path>
    <path fill='#0F9' d='M7 7H8V17H7z'></path>
    <path fill='#9D34FF' d='M16 10H17V18H16z'></path>
    <path fill='#FFFF9C' d='M7 6H14V7H7z'></path>
    <path fill='#0CF' d='M7 17H16V18H7z'></path>
    <path fill='#F66' d='M14 6h1v1.5h1V9h1v1h-3V6z'></path>
  </svg>
);
